export default function InterpretationIcon({
    className,
}: {
    className?: string;
}) {
    return (
        <svg
            className={`${className} w-8 h-8`}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M24.0938 23.7109V25.5089C24.0938 27.9596 22.1071 29.9463 19.6564 29.9463V29.9463C17.2057 29.9463 15.2191 27.9596 15.2191 25.5089V24.6017"
                stroke="currentFill"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M15.078 24.4617C14.0947 24.4617 13.2976 23.6645 13.2976 22.6813C13.2976 21.698 14.0947 20.9009 15.078 20.9009C16.0613 20.9009 16.8584 21.698 16.8584 22.6813C16.8584 23.6645 16.0613 24.4617 15.078 24.4617Z"
                stroke="currentFill"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M20.9059 13.0386H19.9061C19.4766 13.0386 19.1186 13.3965 19.1902 13.8261L19.7093 21.7727C19.7809 22.4886 20.4252 22.9897 21.1411 22.9897H27.0473C27.7633 22.9897 28.336 22.4886 28.4792 21.7727L28.9266 13.8261C28.9982 13.3965 28.7118 13.0386 28.2107 13.0386H27.2109"
                stroke="currentFill"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M26.6006 12.2944V13.6933"
                stroke="currentFill"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M21.5137 12.2944V13.6933"
                stroke="currentFill"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.9375 6L23.9375 6V8.59015H25.9375V6V4L23.9375 4L3.9375 4L1.9375 4V6L1.9375 26.2623V28.2623H3.9375L7.51118 28.2623V26.2623L3.9375 26.2623L3.9375 6Z"
                fill="currentColor"
                stroke="transparent"
            />
        </svg>
    );
}
